<div class="confirm-modal ig-modal show-image-modal">
  <div class="close-button">
    <mat-icon (click)="close()">clear</mat-icon>
  </div>
  <h3 class="title">REFRESH IMAGE</h3>

  <div>
    <!-- Not use ig-image as if the image link is broken, we need to show the broken image to user so that they know not to update the image for the event -->
    <!-- <ig-image *ngIf="data" [imageUrl]="data.data"></ig-image> -->
    <img *ngIf="data" [src]="data.data" alt="Cannot get a correct image for this event. Please click cancel.">
  </div>

  <div class="action-btns">
    <ig-button class="btn-primary" #confirmButton color="primary" size="md" [isAsync]="true"
      (trigger)="confirm($event)">
      OK
    </ig-button>
    <div class="cancel-btn" *ngIf="!confirmButton.isLoading" (click)="close()">
      Cancel
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/show.image.modal/show.image.modal.component.html